<div class="accessibility-wrapper" [class.keyboard-navigation]="isKeyboardNavigation()">
    <h-shell>
        <h-main-content> </h-main-content>
    </h-shell>
    <h-overlay></h-overlay>
    <h-loader ngSkipHydration></h-loader>
    <h-tray-container></h-tray-container>
    <h-svg-symbol></h-svg-symbol>

    <!-- Livechat lazy loaded -->
    <ng-container *ngComponentOutlet="livechat()" />
</div>
